// extracted by mini-css-extract-plugin
export default {"container":"Boxes_container__rPTVU","button":"Boxes_button__UPAcn","alert":"Boxes_alert__+KE7p"};